/** Número de embalagens a dispensar (1 = padrão, sem destaque na impressão). */
export function resolvePrescriptionPackageCount(item: {
  package_count?: number | null;
  is_two_packages?: boolean | null;
}): number {
  const raw = Number(item?.package_count);
  if (Number.isFinite(raw) && raw >= 1) {
    return Math.min(99, Math.floor(raw));
  }
  return item?.is_two_packages ? 2 : 1;
}

export function prescriptionItemPackageFields(packageCount: number): {
  package_count: number;
  is_two_packages: boolean;
} {
  const n = Math.max(1, Math.min(99, Math.floor(Number(packageCount)) || 1));
  return { package_count: n, is_two_packages: n > 1 };
}
